import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import type { Visit } from '../@types/visits';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

// Response structure for the recent visits API
export interface RecentVisitsResponse {
  visits: Visit[];
}

export const useGetRecentVisits = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  const path = `${currentPracticeId}/${endpoints.estimatedVisits}`;

  return useQuery<
    RecentVisitsResponse,
    AxiosError<unknown>,
    RecentVisitsResponse,
    [string, string, string]
  >(
    [path, currentOrganizationId, currentPracticeId],
    async () => {
      const response = await makeAPIRequestReactQuery<RecentVisitsResponse>(
        path,
        { imageTypes: ['BITEWING', 'PERIAPICAL'] },
        'GET',
        {
          headers: { org: currentOrganizationId, practice: currentPracticeId },
        },
      );
      return response;
    },
    {
      enabled: !!currentOrganizationId && !!currentPracticeId,
    },
  );
};
